import React,{useState,useEffect,Fragment} from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import classes from './ReturnInProgressConfirmation.module.css';



const ReturnInProgressConfirmation = (props) =>{
	const handleYes = () =>{
	props.yesClick({id:props.id});

	if (props.inView) {
		props.onClose();
	}
	}

	const handleNo = () =>{
	props.noClick({id:props.id});
	}
	
	return(
	<Modal className={classes.singleModal}>
		<p>Επαναφορά παραγγελίας στις παραγγελίες σε εξέλιξη;</p>
		<div className={classes.buttonGrid}>
		<Button className={classes.confirmation} onClick={handleYes}>Ναι</Button>
		<Button className={classes.confirmation} onClick={handleNo}>Όχι</Button>
		</div>
	</Modal>
	)
}

export default ReturnInProgressConfirmation;